/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityRegionFacility } from './FacilityRegionFacility';
import {
    FacilityRegionFacilityFromJSON,
    FacilityRegionFacilityFromJSONTyped,
    FacilityRegionFacilityToJSON,
} from './FacilityRegionFacility';

/**
 * 
 * @export
 * @interface FacilityRegion
 */
export interface FacilityRegion {
    /**
     * 
     * @type {string}
     * @memberof FacilityRegion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityRegion
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FacilityRegion
     */
    facility_use_count: number;
    /**
     * 
     * @type {Array<FacilityRegionFacility>}
     * @memberof FacilityRegion
     */
    facilities: Array<FacilityRegionFacility>;
    /**
     * 
     * @type {string}
     * @memberof FacilityRegion
     */
    date_created: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityRegion
     */
    date_modified: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FacilityRegion
     */
    updated_by_user?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FacilityRegion interface.
 */
export function instanceOfFacilityRegion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_use_count" in value;
    isInstance = isInstance && "facilities" in value;
    isInstance = isInstance && "date_created" in value;
    isInstance = isInstance && "date_modified" in value;

    return isInstance;
}

export function FacilityRegionFromJSON(json: any): FacilityRegion {
    return FacilityRegionFromJSONTyped(json, false);
}

export function FacilityRegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityRegion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_use_count': json['facility_use_count'],
        'facilities': ((json['facilities'] as Array<any>).map(FacilityRegionFacilityFromJSON)),
        'date_created': json['date_created'],
        'date_modified': json['date_modified'],
        'updated_by_user': !exists(json, 'updated_by_user') ? undefined : json['updated_by_user'],
    };
}

export function FacilityRegionToJSON(value?: FacilityRegion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'facility_use_count': value.facility_use_count,
        'facilities': ((value.facilities as Array<any>).map(FacilityRegionFacilityToJSON)),
        'date_created': value.date_created,
        'date_modified': value.date_modified,
        'updated_by_user': value.updated_by_user,
    };
}

